/*
 * @Author: liumingyang 18268117011@163.com
 * @Date: 2026-07-31 12:39:29
 * @LastEditors: liumingyang 18268117011@163.com
 * @LastEditTime: 2026-08-06 10:28:13
 * @FilePath: \databrain-main-frame\src\pages\home\utils\dynamicString\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { get } from 'lodash-es';
import dynamicStringFnMap from './dynamicStringFnMap';

/**
 * @description: 处理动态字符串取值
 * @param {string} str 字符串，如：'总数：{{total|dataFormat;thousandsInit}}'
 * @param {{ [key: string]: any; }} orgVal 数据源， 如：{ total : 123456 }
 * @param {string} defaultStr 解析不到时，返回的值
 * @return {string} '总数: 123,456'
 */
export const dynamicString = (
  str: string,
  orgVal?: { [key: string]: any; },
  defaultStr = '',
): string => {
  if (typeof str !== 'string' || !str) {
    return defaultStr;
  }
  // 全局匹配所有{{...}}的内容
  return str?.replace(/\{\{(.*?)\}\}/g, (_, g) => {
    //  切分属性路径和函数集合
    const [path, ...fnList] = g.split('|');
    // 解析属性值
    let current = get(orgVal || {}, path?.trim(), defaultStr);

    if (fnList?.length > 0) {
      fnList.forEach((fnStr: string) => {
        // 切分函数名和参数
        const [fnName, ...params] = fnStr?.trim()?.split(';');
        // 获取映射的函数
        const fn: Function =
          dynamicStringFnMap[fnName?.trim() as keyof typeof dynamicStringFnMap];

        if (fn) {
          current = fn(current, ...params?.map((param) => param?.trim()));
        }
      });
    }
    return current;
  });
};
